import * as styles from "./YearPickerTrigger.css";

import { clsx } from "clsx";
import type { KeyboardEvent, PointerEvent } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";
import type { BaseUIEvent } from "@base-ui/react/types";
import { Icon } from "@frontend/components/atoms/Icon";
import { pointerOffsetIn } from "@frontend/utils/pointerAlign";

import { useYearPickerContext } from "./YearPicker.context";
import type { YearPickerTriggerProps } from "./YearPicker.types";

export function YearPickerTrigger({
  className,
  children,
  onPointerDown,
  onKeyDown,
  ...props
}: YearPickerTriggerProps) {
  const { size, layout, disabled, pointerOffsetRef } = useYearPickerContext();

  const isText = layout === "text";

  function handlePointerDown(
    event: BaseUIEvent<PointerEvent<HTMLButtonElement>>,
  ) {
    pointerOffsetRef.current = pointerOffsetIn(
      event.currentTarget,
      event.clientX,
    );

    onPointerDown?.(event);
  }

  function handleKeyDown(event: BaseUIEvent<KeyboardEvent<HTMLButtonElement>>) {
    if (event.key === "Enter" || event.key === " ") {
      pointerOffsetRef.current = 0;
    }

    onKeyDown?.(event);
  }

  return (
    <BasePopover.Trigger
      data-slot="year-picker-trigger"
      disabled={disabled}
      className={clsx(
        isText ? styles.textTrigger : styles.trigger({ size }),
        className,
      )}
      onPointerDown={handlePointerDown}
      onKeyDown={handleKeyDown}
      {...props}
    >
      {children}
      <span className={isText ? styles.textIcon : styles.icon}>
        <Icon name="Calendar" />
      </span>
    </BasePopover.Trigger>
  );
}
